import { render } from "./ApiGuideFuneralPage.vue?vue&type=template&id=63499a64"
import script from "./ApiGuideFuneralPage.vue?vue&type=script&lang=js"
export * from "./ApiGuideFuneralPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__